import React, { FC, ReactNode } from "react";
import { Label, Switch } from "evergreen-ui";

interface Props {
    label?: string;
    description?: ReactNode;
    checked: boolean;
    onChange: () => void;
}

export const LabelledSwitch: FC<Props> = ({ label, description, checked, onChange }) => {
    return (
        <div style={{ marginBottom: 24 }}>
            {label && <Label>{label}</Label>}
            {description && <div>{description}</div>}
            <Switch
                checked={checked}
                marginTop={6}
                onChange={onChange}
            />
        </div>
    );
};
